import _implicitStylesheets from "./gridItem.css";
import _implicitScopedStylesheets from "./gridItem.scoped.css?scoped=true";
import {freezeTemplate, registerTemplate} from "lwc";
const stc0 = {
  key: 0
};
const stc1 = [];
function tmpl($api, $cmp, $slotset, $ctx) {
  const {s: api_slot} = $api;
  return [api_slot("", stc0, stc1, $slotset)];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = [""];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-af9ouu0ctk";
tmpl.legacyStylesheetToken = "undefined-_gridItem";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
